// Normaliza pra 'YYYY-MM-DD', aceitando string ou objeto Date — mesmo
// motivo do backend (calcularMultaJurosAtraso.js): String(dateObj) não dá
// uma data válida pro slice(0,10). Aqui os dados normalmente já chegam como
// string (JSON), mas mantém a mesma robustez do lado do servidor.
function paraDataISO(d) {
  if (d == null) return null;
  if (d instanceof Date) {
    if (isNaN(d)) return null;
    const ano = d.getFullYear(), mes = String(d.getMonth() + 1).padStart(2, '0'), dia = String(d.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }
  const s = String(d).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : null;
}

// Mesma fórmula do backend (backend/src/utils/calcularMultaJurosAtraso.js) —
// só pra sugerir em tela antes de enviar; quem decide de verdade é o servidor.
export function calcularMultaJurosAtraso(valorBase, dataVencimento, dataRecebimento, org) {
  const vencISO  = paraDataISO(dataVencimento);
  const recebISO = paraDataISO(dataRecebimento);
  if (!vencISO || !recebISO) return { multa: 0, juros: 0, diasAtraso: 0 };
  const venc  = new Date(`${vencISO}T00:00:00`);
  const receb = new Date(`${recebISO}T00:00:00`);
  const diasAtraso = Math.max(0, Math.round((receb - venc) / 86400000));
  const carencia   = parseInt(org?.carencia_atraso_dias) || 0;

  if (diasAtraso <= carencia) return { multa: 0, juros: 0, diasAtraso };

  const multaPct = Math.max(0, parseFloat(org?.multa_atraso_pct) || 0);
  const jurosPct = Math.max(0, parseFloat(org?.juros_atraso_pct_mes) || 0);
  const base     = Math.max(0, parseFloat(valorBase) || 0);

  const multa = Math.round(base * (multaPct / 100) * 100) / 100;
  const juros = Math.round(base * (jurosPct / 100) * (diasAtraso / 30) * 100) / 100;

  return { multa, juros, diasAtraso };
}
